import axios from 'axios';

const updateTour = async (
  tourId: string,
  options: {
    name: string;
    date: number;
    tourItemOrder: string[];
    tourItemTimes: {
      tourItemId: string;
      time: Date | string;
      timeEnd: Date | string;
    }[];
    tourItemNotes: {
      tourItemId: string;
      note?: string;
    }[];
    buyers: string[];
  },
) => {
  const { data } = await axios.post<{ pendingBuyers?: boolean }>(
    `/tours/${tourId}/update_tour`,
    {
      ...options,
    },
  );
  return data;
};

export default updateTour;
